/* 
  This is the service responsible for saving all the measured values to the 'database' (a csv file) at: `${PATH}/${this.#fermentationId}/values.csv`
  We start logging on the fermentationstart event
  We stop logging on the fermentationstop event
*/

import * as fs from "filesystem";

const PATH = "/home/pi/fermentations";

class Dummy {
  constructor() {
  }
}


class CsvLogService extends Dummy {
  constructor(...args) {
    super(...args);
        
    this.addEventListener("fermentationstart", this.#fermentationstart_handler.bind(this));
    this.addEventListener("fermentationstop", this.#fermentationstop_handler.bind(this));    
  }
  #fermentationId = null
  #update_handler_f = null
  /* when a farmentation starts we will send progress riport in requested intervals */
  #fermentationstart_handler(event) {
    var fermentation = event.detail;
    this.#fermentationId = fermentation.id;
  	this.#update_handler_f = this.#update_handler.bind(this);
    this.addEventListener("update", this.#update_handler_f);
  }
  /* when the fermentation stops we stop sending progress riport */
  #fermentationstop_handler() {    
    this.removeEventListener("update", this.#update_handler_f);
    this.#fermentationId = null;
    this.#update_handler_f = null;
  }  
  #update_handler(event) {
    var devices = event.detail;
    //console.log(JSON.stringify(devices));
    //console.log("logging csv");
    fs.appendFileSync(`${PATH}/${this.#fermentationId}/values.csv`, `${new Date()},${devices.temperatureSensor.value},${devices.pHSensor.value},${devices.co2Sensor ? devices.co2Sensor.value : "-"},${devices.o2Sensor ? devices.o2Sensor.value : "-"},${devices.dissolvedOxygenSensor.value},${devices.thermostat.percentage},${devices.thermostat.mode},${devices.thermostat.voltage},${devices.thermostat.current},${devices.thermostat.power},${devices.stirring.rpm},${devices.acidPump.mlh},${devices.acidPump.sumML},${devices.basePump.mlh},${devices.basePump.sumML},${devices.feedPump.mlh},${devices.feedPump.sumML},${devices.antifoamPump.mlh},${devices.antifoamPump.sumML},${devices.airflow ? devices.airflow.value : "-"}\n`);
  }      
}

export default CsvLogService;